import * as _ from 'lodash';

import {module} from '../app';

module.config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('errorHttpIntercept');
  }])
  .factory('errorHttpIntercept', ['$q', 'localStorage', '$rootScope', function($q, localStorage, $rootScope) {
    function getUser() {
      let userLoginKey = 'UserLogin';
      let magViewUserName = 'MagViewUserName';
      let magViewRoles = 'magViewRoles';

      if (!localStorage.get(userLoginKey)) {
        return null;
      }

      return {
        login: localStorage.get(userLoginKey),
        userName: localStorage.get(magViewUserName),
        roles: localStorage.get(magViewRoles)
      };
    }

    return {
      'responseError': function(error) {
        if ((error.status < 100 || error.status >= 400) && error.config.url.indexOf('api/logging/logTechpadErrors') < 0) {
          if (error.status === 409) {
            // wrong version
            console.log('Incompatible version');
            $rootScope.$emit('auth:logout');

            return $q.reject(error);
          }

          console.log('ErrorSync: error occured');
          let errorObject =  {
            status: error.status,
            method: error.config.method,
            url: error.config.url,
            data: error.data,
            timestamp: new Date(),
            hospital: localStorage.getObject('hospital'),
            user: getUser(),
            device: localStorage.getObject('MagViewDeviceInfo')
          };

          let errorsStorage = localStorage.getObject('errorsStorage');
          if (!errorsStorage.errors) {
            errorsStorage = { errors: [] };
          }

          if (errorsStorage.errors.length >= 100) {
            errorsStorage.errors.shift();
          }

          errorsStorage.errors.push(errorObject);
          localStorage.setObject('errorsStorage', errorsStorage);

        }
        return $q.reject(error);
      }
    };
  }])

  .service('errorSyncService', ['$http', '$interval', 'authService', 'localStorage', '$rootScope', function($http, $interval, authService, localStorage, $rootScope) {
    let promise = null;

    this.startSync = startSync;
    this.logError = logError;

    $rootScope.$on('status-change', function(ev, data) {
      if (data.isOnline) {
        startSync();
      } else {
        stopSync()
      }
    });

    function logError(errorObject) {
      errorObject.timestamp = new Date();
      errorObject.hospital = localStorage.getObject('hospital');
      errorObject.user = getUser();
      errorObject.device = localStorage.getObject('MagViewDeviceInfo');

      let errorsStorage = localStorage.getObject('errorsStorage');
      if (!errorsStorage.errors) {
        errorsStorage = { errors: [] };
      }

      if (errorsStorage.errors.length >= 100) {
        errorsStorage.errors.shift();
      }

      errorsStorage.errors.push(errorObject);
      localStorage.setObject('errorsStorage', errorsStorage);
    }


    function startSync() {
      stopSync();
      console.log('ErrorSync: starting..');
      promise = $interval(syncErrors, 120000)
    }

    function stopSync() {
      if (promise) {
        $interval.cancel(promise);
        promise = null;
        console.log('ErrorSync: stopping..');
      }
    }

    function getUser() {
      if (!authService.loggedIn) {
        return null;
      }
      let userLoginKey = 'UserLogin';
      let magViewUserName = 'MagViewUserName';
      let magViewRoles = 'magViewRoles';
      return {
        login: localStorage.get(userLoginKey),
        userName: localStorage.get(magViewUserName),
        roles: localStorage.get(magViewRoles)
      };
    }

    function syncErrors() {
      if (!authService.loggedIn) {
        return;
      }

      let errorsStorage = localStorage.getObject('errorsStorage');
      if (!errorsStorage.errors || !errorsStorage.errors.length) {
        return;
      }

      let errors = errorsStorage.errors;
      localStorage.setObject('errorsStorage', { errors: [] });
      console.log('ErrorSync: sending errors..');
      $http.post(authService.currentMagViewUrl() + '/api/logging/logTechpadErrors', errors).then(function() {
        // all errors send successfully
      }, function(){
        // failed to send log
        let errorsStorage = localStorage.getObject('errorsStorage');
        errorsStorage.errors = _.union(errors, errorsStorage.errors);
        localStorage.setObject('errorsStorage', errorsStorage);
      });

    }
  }]);



// WEBPACK FOOTER //
// ./src/scripts/services/errorHttpIntercept.js